export class DateRange {
  FromDate: string;
  ToDate: string;
}
